import { useDomainGoToPath } from 'domains/retailer-collections/utils/domain/routing'

/**
 * Provides a function to navigate the user to the retailer collections page.
 *
 * @returns a function which, when invoked, navigates the user to the edit page
 */
export const useGoToRetailerCollections = () => useDomainGoToPath('retailer-collections-browse')
